import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EmailOptInMetaDataLego } from '../../shared/dto/email-optin-metadata.lego';
import { ConfigServiceService } from '../../../config/shared/config-service.service';
import { EmailNotificationSettingsDto } from '../../../admin/global-settings/shared/dto/email-notification-settings.dto';
import { TranslationService } from '../../../shared';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-email-optin-lego-edit',
  templateUrl: './email-optin-lego-edit.component.html',
  styleUrls: ['./email-optin-lego-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class EmailOptInLegoEditComponent implements OnInit, OnChanges {
  @Input() emailOptInData: EmailOptInMetaDataLego;
  public optOutDefault: boolean;
  constructor(
    private _configServiceService: ConfigServiceService,
    private _translationService: TranslationService
  ) {}

  ngOnInit(): void {
    this._configServiceService.getEmailNotificationSettings().then((data: EmailNotificationSettingsDto) => {
      this.optOutDefault = data.OptOutByDefault;
    })
    if (!this.emailOptInData.Label) {
      this.emailOptInData.Label = this._translationService.getInstant('form-builder.legos.email-optin.label.default');
    }
    if (!this.emailOptInData.Message) {
      this.emailOptInData.Message = this._translationService.getInstant('form-builder.legos.email-optin.message.default');
    }
  }

  ngOnChanges(): void {}
}
